<app-header
    [langSel]="selectedLanguage"
    (selectedLanguage)="switchedLanguage($event)"
/>

<main class="tw-py-16 md:tw-py-20">
    <section class="tw-px-[5vw] tw-flex tw-flex-col">
        <span class="tw-font-semibold tw-text-[24px]">
            {{"MYKNP_PAGE.HEADING" | translate}}
        </span>
        <span class="tw-mt-1 tw-text-black">
            {{"MYKNP_PAGE.SUB_HEADING" | translate}}
        </span> 
        <img
            class="tw-mt-4" 
            src="/assets/images/myknp-Infographic-{{selectedLanguage}}.webp"
            alt="Language"
        />
        <div class="tw-flex tw-flex-row tw-justify-center tw-gap-1 tw-mx-5 md:tw-mx-0">
            <span
                class="tw-italic tw-font-medium">
                {{"MYKNP_PAGE.KNOW_MORE" | translate}}
                <a 
                    class="tw-text-blue-600 tw-underline tw-italic"
                    [routerLink]="['/faq']"
                    [queryParams]="{segment: SEGMENTS.MYKNP}">
                    {{"MYKNP_PAGE.KNOW_MORE_CTA" | translate}}.
                </a>
            </span>
        </div>
        <img
            class="tw-mt-4" 
            src="/assets/images/myknp-footer-{{selectedLanguage}}.jpg"
            alt="Language"
        />   
    </section>
</main>

<app-footer
    [selectedLanguage]="selectedLanguage"
/>
